import React, { useState, useEffect } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { PropertiesSection } from '../components/PropertiesSection';
import { AgentSection } from '../components/AgentSection';
import { SocialFeedSection } from '../components/SocialFeedSection';
import { MarketSection } from '../components/MarketSection';
import { PropertyAlertsSection } from '../components/PropertyAlertsSection';
import { MortgageCalculator } from '../components/MortgageCalculator';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { LiveChatWidget } from '../components/LiveChatWidget';
import { translations } from '../mock';
import { propertiesAPI } from '../lib/api';
import { siteAPI } from '../lib/api';
import { Toaster } from '../components/ui/sonner';

export const LandingPage = () => {
  const [language, setLanguage] = useState('sq');
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);
  const t = translations[language];

  useEffect(() => {
    loadProperties();
    loadContent();
  }, []);

  const loadProperties = async () => {
    try {
      const data = await propertiesAPI.list({ featured: true });
      setProperties(data);
    } catch (err) {
      console.error('Failed to load properties:', err);
    } finally {
      setLoading(false);
    }
  };

  const loadContent = async () => {
    try {
      const data = await siteAPI.get();
      setContent(data);
    } catch (err) {
      console.error('Failed to load site content:', err);
    }
  };

  const handleNavigate = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <Header
        t={t}
        lang={language}
        onLanguageChange={setLanguage}
        onNavigate={handleNavigate}
      />
      <HeroSection t={t} content={content} lang={language} onNavigate={handleNavigate} />
      <AboutSection t={t} content={content} lang={language} />
      <ServicesSection t={t} content={content} lang={language} />
      <PropertiesSection t={t} properties={properties} lang={language} loading={loading} />
      <AgentSection t={t} />
      <SocialFeedSection lang={language} />
      <MarketSection t={t} lang={language} />
      <MortgageCalculator lang={language} initialPrice={properties[0]?.price || 250000} />
      <PropertyAlertsSection t={t} lang={language} />
      <ContactSection t={t} content={content} lang={language} />
      <Footer t={t} onNavigate={handleNavigate} />
      <LiveChatWidget />
      <Toaster />
    </div>
  );
};
